var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.25C4.00781 0.25 0 4.29297 0 9.25C0 14.2422 4.00781 18.25 9 18.25C13.957 18.25 18 14.2422 18 9.25C18 4.29297 13.957 0.25 9 0.25ZM13.043 7.70312L8.54297 12.2031C8.36719 12.4141 8.12109 12.4844 7.875 12.4844C7.59375 12.4844 7.34766 12.4141 7.17188 12.2031L4.92188 9.95312C4.53516 9.56641 4.53516 8.96875 4.92188 8.58203C5.30859 8.19531 5.90625 8.19531 6.29297 8.58203L7.875 10.1289L11.6719 6.33203C12.0586 5.94531 12.6562 5.94531 13.043 6.33203C13.4297 6.71875 13.4297 7.31641 13.043 7.70312Z",
    fill: "#00ac7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.efc22c57669f6b070416492a7f0f6ba2.svg";
export { ForwardRef as ReactComponent };